import CurrencySelector from '@/components/CurrencySelector/CurrencySelector';
import LanguageSelector from '@/components/LanguageSelector/LanguageSelector';
import Logo from '@/components/Logo';
import { SITE_NAME, SOCIALS } from '@/config';
import { useMediaQuery } from '@/hooks';
import { capitalize } from '@/utils';

import PreFooter from './Prefooter';
import Sitemap from './Sitemap/Sitemap';
import SitemapMobile from './Sitemap/SitemapMobile';

function Footer({ prefooter }) {
	const mdDown = useMediaQuery('mdDown');

	return (
		<footer className="relative flex justify-center bg-black">
			<div className="container flex justify-center">
				<div className="flex w-full flex-col justify-between pb-11 pt-16 text-center lg:pb-[75px] lg:pt-[54px]">
					{prefooter && <PreFooter />}

					<div className="mb-[52px] mt-[44px] flex flex-col items-start justify-between lg:mb-[143px] lg:mt-0 lg:flex-row">
						<Logo size="lg" />

						{mdDown ? <SitemapMobile /> : <Sitemap />}
					</div>

					<div className="flex flex-col-reverse items-center justify-between md:flex-row">
						<div className="flex w-full items-center justify-between">
							<span className="inline-flex text-left text-xs text-grey-500 lg:mb-0 lg:mr-[90px]">
								{new Date().getFullYear()} © {SITE_NAME}
							</span>

							<div className="flex gap-3 md:hidden">
								{SOCIALS.map(({ key, url, Icon }) => (
									<a
										key={`social-footer--${key}`}
										href={url}
										target="_blank"
										rel="noopener noreferrer"
										aria-label={capitalize(key)}
									>
										<Icon className="text-red" />
									</a>
								))}
							</div>
						</div>
						<div className="mb-[52px] flex items-center gap-[20px] md:mb-0">
							<CurrencySelector footer />
							<LanguageSelector footer />
							<div className="ml-[128px] hidden gap-3 md:flex">
								{SOCIALS.map(({ key, url, Icon }) => (
									<a
										key={`social-footer--${key}`}
										href={url}
										target="_blank"
										rel="noopener noreferrer"
										aria-label={capitalize(key)}
									>
										<Icon className="text-red transition-colors hover:text-white" />
									</a>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
